import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './components/App';
import Page from './components/Page';

// eslint-disable-next-line no-unused-vars
export default urlGenerator => (
    <Route path="/" component={App}>
        <Route
            path={urlGenerator.route('post', {
                forRouter: true,
            })}
            component={Page}
        />
        <Route
            path={urlGenerator.route('page', {
                forRouter: true,
            })}
            component={Page}
        />
        <Route
            path={urlGenerator.route('hub', {
                forRouter: true,
            })}
            component={Page}
        />
        <IndexRoute component={Page} />
    </Route>
);



// WEBPACK FOOTER //
// ./routes.jsx